<template>

<v-app>
    <TopBar  />
    <LeftMenu ></LeftMenu>
    <Vtoast ref="Vtoast" :callBack="vtoastCallback" />

    <div class="pa-5" >
      
      <v-card elevation="0" outlined>
        <v-card-title>Edit Teacher </v-card-title>

        <div class="pa-5"> 
          <v-form ref="form" >
            <v-text-field outlined v-model="teacherName" label="Name Surname"  ></v-text-field>
            <v-text-field outlined v-model="teacherEmail"  label="Email Address"  ></v-text-field>
            <v-text-field outlined v-model="teacherPassword"  label="Password"  ></v-text-field>
            <div>* if you don't want to change password, please don't write anything for password!</div>
          </v-form>
        </div>

        <v-card-actions class="pt-0" >
          <v-spacer></v-spacer>
          <v-btn to="/eisadmin/teachers" color="error" small elevation="0" class="mb-2 mr-2 mt-2" >CANCEL</v-btn>
          <v-btn class="float-right" @click="submit" small color="primary" >Save</v-btn>
        </v-card-actions>

      </v-card>

    </div>

</v-app>

</template>

<script>

  import checkAuth from '../../mixins/checkAuth';
  import LeftMenu from '../../views/eisadmin/components/LeftMenu'
  import TopBar from '../../views/eisadmin/components/TopBar'
  import { mdiMagnify, mdiBellOutline, mdiGithub, mdiAlertRhombus, mdiCheckBold } from '@mdi/js'
  import axios from 'axios';
  import Vtoast from '../../views/eisadmin/components/Vtoast';


  export default {
    mixins: [checkAuth],
    components: { LeftMenu, TopBar, Vtoast },

    setup() {
      return {
        icons: {
          mdiMagnify, mdiBellOutline, mdiGithub,},
      }
    },

    data: () => ({

      teacherName: '',
      teacherEmail: '',
      teacherPassword: '',

    }),

    methods: {
      getData(teacherId) {
        
        const data = { teacherId : teacherId }
        axios.post(process.env.VUE_APP_API_DOMAIN + "/teacher",JSON.stringify(data)
        ,{ headers: {'Authorization': 'Bearer ' + this.$store.getters.getAccessToken } })
        .then(
          response => {
            this.teacherEmail = response.data.teacher.teacherEmail;
            this.teacherName = response.data.teacher.teacherName;
          }  
        );

      },
      submit () {
        
        if(this.teacherName == "" || this.teacherEmail == ""){
          this.$root.Vtoast.show({message: 'Please write name and email!', snackType: 'fail', color: 'warning', icon: mdiAlertRhombus})
        }else{
          
          const data = {
            teacherName : this.teacherName,
            teacherEmail : this.teacherEmail,
            teacherPassword : this.teacherPassword,
            teacherId : this.$route.params.teacherId,

          }

          axios.post(process.env.VUE_APP_API_DOMAIN + "/teacher_save",JSON.stringify(data)
          ,{
              headers: {
                'Authorization': 'Bearer ' + this.$store.getters.getAccessToken  
              }
            }
          ).then(
            response => {
              console.log(response);
              if(response.data.result == "success"){
                this.$root.Vtoast.show({message: 'Teacher is saved succesfully!', snackType: 'success', color: 'success', icon: mdiCheckBold })
              }else{
                this.$root.Vtoast.show({message: 'An error occurred!', snackType: 'fail', color: 'warning', icon: mdiAlertRhombus})
              }

            }  

          );

        }

      },
      vtoastCallback() {
        this.$router.push('/eisadmin/teachers');
      }
      
    },
    created() {},
    mounted() {
      this.$root.Vtoast = this.$refs.Vtoast
      this.getData(this.$route.params.teacherId);
    },
  }
</script>

